export default __webpack_public_path__ + "static/SFMono-Semibold-ee054046915420413d0068fb1e7105c3.woff";